// extracted by mini-css-extract-plugin
export default {"checkboxCircle":"SigninPage_checkboxCircle__RtYkk","rouned-checkbox":"SigninPage_rouned-checkbox__nJEam"};